export var PLAYLISTS_PER_PAGE = 100;
export function getPlaylistPageNumber(index) {
  var page = Math.ceil(index / PLAYLISTS_PER_PAGE) || 1;
  return page;
}